// extracted by mini-css-extract-plugin
module.exports = {"style":"_13tNfs45qKmkBTiyrsm6aR"};